import type { PokerSuit } from './PokerSuit';

export const pokerSuitIndexMap: { [suit in PokerSuit]: number } = {
  c: 0,
  d: 1,
  h: 2,
  s: 3,
};
